<template>
  <div class="code-entry">
    <div class="text-center">
      <h2 class="text-xl font-semibold mb-4">
        {{ $t('code_entry.title', 'Enter Access Code') }}
      </h2>
      
      <form @submit="handleFormSubmit" class="max-w-sm mx-auto">
        <div class="mb-4">
          <input
            type="text"
            v-model="code"
            @input="handleInputChange"
            :placeholder="$t('code_entry.placeholder', 'Enter code')"
            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            required
          />
        </div>
        
        <button
          type="submit"
          class="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 focus:ring-2 focus:ring-blue-500"
        >
          {{ $t('code_entry.submit', 'Submit') }}
        </button>
      </form>
      
      <p class="text-sm text-gray-600 mt-4">
        {{ $t('code_entry.help', 'Please enter the access code to view this content') }}
      </p>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'VueCodeEntry',
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },
    handleChange: {
      type: Function,
      required: true
    },
    tourSettings: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const code = ref('')
    
    const handleInputChange = (event) => {
      code.value = event.target.value
      props.handleChange(event)
    }
    
    const handleFormSubmit = (event) => {
      event.preventDefault()
      props.handleSubmit(event)
    }
    
    return {
      code,
      handleInputChange,
      handleFormSubmit
    }
  }
}
</script>

<style scoped>
.code-entry {
  padding: 2rem;
}
</style> 